import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Roles } from "@/domains/shared/models/roles";
import { Navigate, Outlet, useLocation } from "react-router";

function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

/**
 * When a parent has no linked professional yet, only `/familia/perfil` is reachable;
 * other `/familia/*` routes redirect there.
 */
export default function ParentFamiliaLinkedGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || !user) {
return null;
}

  const blocked =
    user.role === Roles.Parent && user.hasLinkedProfessional === false;
  if (!blocked) {
return <Outlet />;
}

  const p = normalizePath(location.pathname);
  if (p === "/familia/perfil") {
return <Outlet />;
}
  if (p === "/familia" || p.startsWith("/familia/")) {
    return <Navigate to="/familia/perfil" replace />;
  }

  return <Outlet />;
}
